import { render, staticRenderFns } from "./OpeningClosingContent.vue?vue&type=template&id=07f02cb6&"
import script from "./OpeningClosingContent.vue?vue&type=script&lang=js&"
export * from "./OpeningClosingContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInput});
